import { veeduriaTypes } from '../../types/veeduriaTypes'

export const insertVeeduria = ( payload ) => ({
    type: veeduriaTypes.VEEDURIA_SAVE_START,
    payload
})


export const downloadConstancia = ( payload ) => ({
    type: veeduriaTypes.VEEDURIA_DOWNLOAD_START,
    payload
})
